// Bootstrap
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-theme.min.css';
import 'react-bootstrap-modal/lib/css/rbm-patch.css';

// AdminLTE theme
import 'admin-lte';
import 'admin-lte/dist/css/AdminLTE.css';
import 'admin-lte/dist/css/skins/skin-blue.css';

import './style/app.css';
import './style/flags.css';

import 'semantic-ui-css/semantic.min.css'
import './style/fonts.css';
import './style/styles.scss';

// Map leaflet
import 'leaflet/dist/leaflet.css';

// Fonts
import 'glyphicons';
import 'font-awesome/css/font-awesome.css';

// Other useful plugins
import 'fastclick';
import 'jquery-slimscroll';
import 'react-select/dist/react-select.css';

// Date picker
import 'bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

// React
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

// Main page components
// import Header from './header/header.jsx';
// import Menu from '../menu/menu.jsx';
import Menu from '../menu/menu_v2';
import Footer from './footer.jsx';

// Pages
import LoginSSO from '../pages/login/ssoLogin.jsx';
import Login from '../pages/login/login.jsx';
import CalcPage from '../pages/calc/calcPage.jsx';
import TrackingPage from '../pages/tracking/trackingPage.jsx';
import Home from '../pages/home.jsx';
import ParcelsTable from '../pages/parcels/table/parcelsTable.jsx';
import ParcelsTableNew from '../pages/parcels/table/parcelsTableNew.jsx';
import CreateParcelForm from '../pages/parcels/form/createParcelForm.jsx';
import CreateParcelForm2 from "../pages/parcels/form_v2/createParcelForm.jsx";
import CreateParcelForm3 from "../pages/parcels/form_v3/createParcelForm.jsx";
import ParcelForm from '../pages/parcels/form/parcelForm.jsx';
import ParcelForm3 from '../pages/parcels/form_v3/parcelForm';
import AdminCompaniesTable from "../pages/admin/companies/companiesTable.jsx";
import AdminCompaniesForm from "../pages/admin/companies/companiesForm.jsx";
import AdminRatesTable from "../pages/admin/rates/ratesTable.jsx";
import AdminRatesForm from "../pages/admin/rates/ratesForm.jsx";
import AdminUsersTable from '../pages/admin/users/usersTable.jsx';
import AdminUserForm from '../pages/admin/users/userForm.jsx';
import StatisticsPage from '../pages/statistics.jsx';
import NotFound from '../pages/notFound/notFound.jsx';
import BorderInsurance from '../pages/insurance/borderInsurance.jsx';

//Services
import {validateToken} from '../services/apiClient';
import ConfirmModal from '../modals/confirmModal.jsx';

import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Calc from "../pages/calc/calc";
import MyReports from "../pages/reports/myReports";
import DictionaryList from "../pages/dictionaries/dictionaryList";
import DictionaryCard from "../pages/dictionaries/dictionaryCard";
import {getCurrentUserLogin, getUserData} from "../services/userRights";
import {getSessionJivoToken} from "../services/session";

export default class App extends React.Component {
    constructor(args) {
        super(args);
        this.state = {
            isLoading: true
        }
        this.isFirstLoadedRender = true;
        this.confirmModal = null;
    }

    componentDidMount() {
        validateToken().then(() => {
            this.setState({
                isLoading: false
            });

            window.jivo_onLoadCallback = () => {
                this.setJivoData();
            }
        });
    }

    setJivoData = () => {
        if (window.jivo_api && window.jivo_api.setUserToken && getSessionJivoToken()) {
            window.jivo_api.clearHistory();
            // передаем данные о пользователе в JIVO
            window.jivo_api.setUserToken(getSessionJivoToken());
            window.jivo_api.setContactInfo({
                name: `${getUserData().UserSurname || ''} ${getUserData().UserName || ''} ${getUserData().UserPatronymic || ''}`,
                email: getUserData().Email,
                phone: getUserData().ContactInfo,
                description: getCurrentUserLogin()
            });
        } else {
            setTimeout(() => {
                this.setJivoData();
            }, 200)
        }
    }

    componentWillUnmount() {
        window.jivo_api && window.jivo_api.clearHistory();
    }

    getChangeRouteConfirmation(message, callback) {
        this.confirmModal.open("Подтверждение перехода на другую страницу", message)
            .then(() => {
                callback(true);
            })
            .catch(() => {
                callback(false);
            });
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div className="loading">
                    <img src="/img/spinner.gif" alt="loading"/>
                </div>
            );
        } else {
            if (this.isFirstLoadedRender) {
                this.isFirstLoadedRender = false;
                setTimeout(() => {
                    $(window).trigger('resize');
                    $('ul.tree').tree();
                }, 100);
            }
            return (
                <div>
                    <ToastContainer
                        position="bottom-left"
                        hideProgressBar={true}
                    />
                    <Router
                        getUserConfirmation={(message, callback) => this.getChangeRouteConfirmation(message, callback)}>
                        <Switch>
                            <Route exact path="/login" component={Login}/>
                            <Route exact path="/sso/login" component={LoginSSO}/>
                            {/*<Route exact path="/calc" component={CalcPage}/>*/}
                            <Route exact path="/calc" component={Calc}/>
                            <Route exact path="/calc2" component={Calc}/>
                            <Route exact path="/tracking" component={TrackingPage}/>
                            <Route exact path="/admin/stats" component={StatisticsPage}/>
                            <Route>
                                <div className="">
                                    <Menu/>

                                    <div className="page-container">
                                        <Switch>
                                            <Route exact path="/" component={Home}/>
                                            <Route path="/admin/companies/list" component={AdminCompaniesTable}/>
                                            <Route path="/admin/companies/new" component={AdminCompaniesForm}/>
                                            <Route path="/admin/companies/:id" component={AdminCompaniesForm}/>

                                            <Route path="/admin/rates/list" component={AdminRatesTable}/>
                                            <Route path="/admin/rates/new" component={AdminRatesForm}/>
                                            <Route path="/admin/rates/:id" component={AdminRatesForm}/>

                                            <Route path="/admin/users/list" component={AdminUsersTable}/>
                                            <Route path="/admin/users/new" component={AdminUserForm}/>
                                            <Route path="/admin/users/:id" component={AdminUserForm}/>

                                            <Route path="/borderInsurance" component={BorderInsurance}/>

                                            <Route path="/parcels/list/new" component={ParcelsTableNew}/>
                                            <Route path="/parcels/list" component={ParcelsTable}/>

                                            <Route path="/parcels/new" component={CreateParcelForm}/>
                                            { /*Form version 2*/}
                                            <Route path="/parcels/new2" component={CreateParcelForm2}/>
                                            {/*Form version 3*/}
                                            <Route path="/parcels/new3" component={CreateParcelForm3}/>
                                            <Route path="/parcels/copy/:copyId" component={CreateParcelForm3}/>
                                            <Route path="/parcels/draft/:draftId" component={CreateParcelForm3}/>
                                            <Route path="/reports/my" component={MyReports}/>
                                            <Route path="/dictionary/:name/new" component={DictionaryCard}/>
                                            <Route path="/dictionary/:name/:id" component={DictionaryCard}/>
                                            <Route path="/dictionary/:name" component={DictionaryList}/>

                                            <Route path="/parcels/:id/new" component={ParcelForm3}/>
                                            <Route path="/parcels/:id" component={ParcelForm}/>
                                            <Route component={NotFound}/>
                                        </Switch>
                                    </div>

                                    <ConfirmModal ref={modal => this.confirmModal = modal}/>
                                </div>
                            </Route>
                        </Switch>
                    </Router>
                </div>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./App/containers/app.jsx